<template>
    <div>
        <slot>
            <span
                v-if="isEmpty"
                class="text-muted"
            >
                (not set)
            </span>

            <template v-else-if="typeof value === 'boolean'">
                <oc-icon v-if="value" type="check" class="checked-icon" />
                <oc-icon v-else type="times" class="unchecked-icon" />
            </template>

            <template v-else>
                <span v-if="viewEscapeValue">{{$_value}}</span>
                <div v-else v-html="$_value" />
            </template>
        </slot>
    </div>
</template>

<script>
export default {
    name: 'oc-field-view',
    props: {
        value: {},
        viewEmptyValues: {
            type: Array,
            default: () => [undefined, null, ""]
        },
        viewEscapeValue: {
            type: Boolean,
            default: true
        }
    },
    computed: {
        $_value() {
            if ( isObject(this.value) || isArray(this.value) ) {
                return toJson(this.value)
            }

            return this.value
        },
        isEmpty() {
            return inArray(this.value, this.viewEmptyValues, true)
        }
    }
}
</script>

<style scoped>
    .checked-icon {color: #28a745;}
    .unchecked-icon {color: #dc3545;}
</style>
